import { useArticle } from '@on3/ui-lib/index';
import { getReferrer, trackGoogle } from '@on3/ui-lib/utils/tracking';
import { useEffect } from 'react';

import styles from './RegWallBarrier.module.scss';

interface RegWallBarrierProps {
  handleRegister: () => void;
  handleLogin: () => void;
}

export const RegWallBarrier = ({
  handleRegister,
  handleLogin,
}: RegWallBarrierProps) => {
  const { article } = useArticle();

  useEffect(() => {
    trackGoogle('regwall_view', {
      location: 'article',
      referrer: getReferrer(),
      articleKey: article?.key || null,
    });
  }, [article?.key]);

  return (
    <div className={styles.block}>
      <div className={styles.container}>
        <h2>Create an account to read this article for free</h2>
        <button className={styles.joinBtn} onClick={handleRegister}>
          Continue
        </button>
        <button className={styles.loginBtn} onClick={handleLogin}>
          Already have an account? Login
        </button>
      </div>
    </div>
  );
};
